module.exports = __webpack_public_path__ + "static/media/icoOption-Selected.4574db99.svg";